import { render } from "./BuzzLatestPostWidget.vue?vue&type=template&id=bcba15e8&scoped=true"
import script from "./BuzzLatestPostWidget.vue?vue&type=script&lang=js"
export * from "./BuzzLatestPostWidget.vue?vue&type=script&lang=js"

import "./buzz-latest-post-widget.scss?vue&type=style&index=0&id=bcba15e8&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcba15e8"]])

export default __exports__